import data from "../../data/index.json";

export default function MyPortfolio() {
  return (
    <section className="portfolio--section" id="MyPortfolio">
      <div className="portfolio--container-box">
        <div className="portfolio--container">
          <p className="sub--title">Neue Projekte</p>
          <h2 className="section--heading">Mein Portfolio</h2>
        </div>
        <div>
          <a
            href="https://github.com/wasb1"
            className="btn btn-github"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M12 0.2975C5.373 0.2975 0 5.67 0 12.2975C0 17.6125 3.438 22.0625 8.205 23.6825C8.805 23.7975 9.025 23.4225 9.025 23.0975C9.025 22.8025 9.015 22.0825 9.01 21.0975C5.6725 21.7975 4.9675 19.4975 4.9675 19.4975C4.4225 18.0975 3.6325 17.7325 3.6325 17.7325C2.5475 17.0225 3.7175 17.0375 3.7175 17.0375C4.9225 17.1275 5.555 18.2875 5.555 18.2875C6.6225 20.1275 8.3725 19.6375 9.0525 19.3275C9.1625 18.5475 9.4725 17.9975 9.8175 17.6825C7.145 17.3675 4.345 16.3175 4.345 11.6375C4.345 10.2975 4.8225 9.2175 5.625 8.3775C5.4925 8.0575 5.0725 6.8075 5.755 5.1075C5.755 5.1075 6.7825 4.7725 9.0025 6.3575C9.9825 6.0775 11.025 5.9375 12.0675 5.9325C13.11 5.9375 14.1525 6.0775 15.1325 6.3575C17.3525 4.7725 18.3775 5.1075 18.3775 5.1075C19.06 6.8075 18.64 8.0575 18.5075 8.3775C19.3125 9.2175 19.7875 10.2975 19.7875 11.6375C19.7875 16.3325 16.9825 17.3625 14.3025 17.6725C14.7425 18.0625 15.1325 18.8425 15.1325 20.0575C15.1325 21.7925 15.1175 22.9775 15.1175 23.0925C15.1175 23.4175 15.3325 23.7975 15.9425 23.6775C20.7075 22.0575 24.1425 17.6125 24.1425 12.2975C24.1425 5.67 18.768 0.2975 12 0.2975Z" />
            </svg>
            Meinen GitHub besuchen
          </a>
        </div>
      </div>

      <div className="portfolio--section--container">
        {data?.portfolio?.map((item, index) => (
          <div key={index} className="portfolio--section--card">
            <div className="portfolio--section--img">
              <img src={item.src} alt={item.title} />
            </div>
            <div className="portfolio--section--card--content">
              <div>
                <h3 className="portfolio--section--title">{item.title}</h3>
                <p className="text-md">{item.description}</p>
                <br />
              </div>

              <a
                className="text-sm portfolio--link"
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
              > <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                  <path d="M12 0.2975C5.373 0.2975 0 5.67 0 12.2975C0 17.6125 3.438 22.0625 8.205 23.6825C8.805 23.7975 9.025 23.4225 9.025 23.0975C9.025 22.8025 9.015 22.0825 9.01 21.0975C5.6725 21.7975 4.9675 19.4975 4.9675 19.4975C4.4225 18.0975 3.6325 17.7325 3.6325 17.7325C2.5475 17.0225 3.7175 17.0375 3.7175 17.0375C4.9225 17.1275 5.555 18.2875 5.555 18.2875C6.6225 20.1275 8.3725 19.6375 9.0525 19.3275C9.1625 18.5475 9.4725 17.9975 9.8175 17.6825C7.145 17.3675 4.345 16.3175 4.345 11.6375C4.345 10.2975 4.8225 9.2175 5.625 8.3775C5.4925 8.0575 5.0725 6.8075 5.755 5.1075C5.755 5.1075 6.7825 4.7725 9.0025 6.3575C9.9825 6.0775 11.025 5.9375 12.0675 5.9325C13.11 5.9375 14.1525 6.0775 15.1325 6.3575C17.3525 4.7725 18.3775 5.1075 18.3775 5.1075C19.06 6.8075 18.64 8.0575 18.5075 8.3775C19.3125 9.2175 19.7875 10.2975 19.7875 11.6375C19.7875 16.3325 16.9825 17.3625 14.3025 17.6725C14.7425 18.0625 15.1325 18.8425 15.1325 20.0575C15.1325 21.7925 15.1175 22.9775 15.1175 23.0925C15.1175 23.4175 15.3325 23.7975 15.9425 23.6775C20.7075 22.0575 24.1425 17.6125 24.1425 12.2975C24.1425 5.67 18.768 0.2975 12 0.2975Z" />
                </svg>

                Auf GitHub ansehen
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 20 19"
                  fill="none"
                >
                  <path
                    d="M4.66667 1.66675H18V15.0001M18 1.66675L2 17.6667L18 1.66675Z"
                    stroke="currentColor"
                    strokeWidth="2.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
              {index === 0 && item.demoUrl && (
                <a
                  className="text-sm portfolio--link"
                  href={item.demoUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginTop: "10px", color: "#e62872", fontWeight: "bold", display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {/* YouTube SVG icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M23.498 6.186a2.906 2.906 0 0 0-2.046-2.054C19.651 3.5 12 3.5 12 3.5s-7.651 0-9.452.632A2.906 2.906 0 0 0 .502 6.186 30.575 30.575 0 0 0 0 12a30.574 30.574 0 0 0 .502 5.814 2.906 2.906 0 0 0 2.046 2.054C4.349 20.5 12 20.5 12 20.5s7.651 0 9.452-.632a2.906 2.906 0 0 0 2.046-2.054A30.574 30.574 0 0 0 24 12a30.575 30.575 0 0 0-.502-5.814ZM9.75 15.5v-7l6.5 3.5-6.5 3.5Z" />
                  </svg>
                  Demo auf YouTube ansehen
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 20 19"
                    fill="none"
                  >
                    <path
                      d="M4.66667 1.66675H18V15.0001M18 1.66675L2 17.6667L18 1.66675Z"
                      stroke="currentColor"
                      strokeWidth="2.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </section >
  );
}
